import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/confirm-delete-dialog/confirm-delete-dialog.component';

@Component({
  selector: 'app-srv-list',
  templateUrl: './srv-list.component.html',
  styleUrl: './srv-list.component.css',
})
export class SRVListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'srNo',
    'reference_code',
    'project_name',
    'domain',
    'voucher_date',
    'item_summary',
    'status',
    'linked_siv',
    'created_by_name',
    'action',
  ];

  dataSource = new MatTableDataSource<any>([]);
  searchKeyword = '';
  statusFilter = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fetchData();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event): void {
    this.searchKeyword = (event.target as HTMLInputElement).value.trim();
    this.fetchData();
  }

  filterByStatus(event: Event): void {
    this.statusFilter = (event.target as HTMLSelectElement).value || '';
    this.fetchData();
  }

  fetchData(): void {
    this.apiService
      .listSrvSivRequests('SRV', {
        search: this.searchKeyword || undefined,
        status: this.statusFilter || undefined,
        limit: 200,
      })
      .subscribe({
        next: (res: any) => {
          this.dataSource.data = res?.data ?? [];
        },
        error: (err) => {
          const msg =
            err?.error?.message ||
            err?.error?.errorMessage ||
            err?.message ||
            'Failed to load SRV list';
          this.toastrMsgService.error(msg);
        },
      });
  }

  deleteSrv(row: any): void {
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: '400px',
      data: { itemName: row.reference_code || `SRV #${row.id}` },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }
      this.apiService.deleteSrvSivRequest(row.id).subscribe({
        next: () => {
          this.toastrMsgService.success('SRV deleted');
          this.fetchData();
        },
        error: (err) => {
          const msg =
            err?.error?.message ||
            err?.error?.errorMessage ||
            err?.message ||
            'Delete failed';
          this.toastrMsgService.error(msg);
        },
      });
    });
  }

  generateSiv(row: any): void {
    if (row.linked_siv_id) {
      this.toastrMsgService.info('An SIV has already been generated for this SRV');
      return;
    }
    void this.router.navigate(['/home/add-siv'], { queryParams: { srvId: row.id } });
  }
}
